module.exports = __webpack_public_path__ + "img/password-gen-details3.6b1605fc.png";